module.exports = __webpack_public_path__ + "img/warning-icon.2e270dea.svg";